import { Button } from '../button'

export default function SubmitButton({
  loading,
  buttonText,
  className,
  variant,
  onClick,
}: {
  loading: boolean
  buttonText?: string
  className?: string
  onClick?: () => void
  variant?:
    | 'calendar'
    | 'transparent'
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link'
    | null
    | undefined
}) {
  return (
    <Button
      disabled={loading}
      onClick={onClick}
      type="submit"
      variant={variant || undefined}
      className={`${className} relative flex items-center justify-center`}
    >
      {/* Spinner */}
      <img
        src="/dots_white.svg"
        className={`absolute w-8 transition-opacity duration-150 ${
          loading ? 'opacity-100' : 'opacity-0'
        }`}
        alt="Loading"
      />

      {/* Button text (invisible when loading) */}
      <span className={`${loading ? 'invisible' : 'visible'}`}>
        {buttonText || 'Submit'}
      </span>
    </Button>
  )
}
